import { render } from "./PiturimM.vue?vue&type=template&id=39c9ccc2&scoped=true"
import script from "./PiturimM.vue?vue&type=script&lang=js"
export * from "./PiturimM.vue?vue&type=script&lang=js"

import "./PiturimM.vue?vue&type=style&index=0&id=39c9ccc2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c9ccc2"]])

export default __exports__